import {
  getViewOrder,
  ViewOrder
} from '../../../gameday/mappers/gameDay-orders.transfomations';
import { GameDayModel } from '../../../models/gameday-model';

function capitalize(s: string): string {
  if (!s) {
    return s;
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function getRecentOrder(order: GameDayModel.Order): ViewOrder {
  const viewOrder = getViewOrder(order);
  const maturityDate = order.maturity && order.maturity.maturityDate;
  if (viewOrder.series && maturityDate) {
    viewOrder.maturity = `${viewOrder.series}: ${maturityDate.format(
      'MM/DD/YYYY'
    )}`;
    const coupon = order.maturity.coupon;
    if (coupon > 0 || coupon === 0) {
      viewOrder.maturity += `, ${coupon.toFixed(3)}%`;
    }
  }

  if (!viewOrder.account) {
    viewOrder.account = capitalize(GameDayModel.OrderPriority[order.priority]);
  }
  return viewOrder;
}

function compareOrdersByNumber(
  order1: GameDayModel.Order,
  order2: GameDayModel.Order
) {
  return order2.orderNumber - order1.orderNumber;
}

export function getRecentOrders(orders: GameDayModel.Order[]) {
  return orders
    .slice()
    .sort(compareOrdersByNumber)
    .map(getRecentOrder);
}
